import {lazy} from 'react';
import GenericFallbackSuspense from '../ui/GenericFallback/GenericFallbackSuspense';

const ReturnToLogin = lazy(() => import('./ReturnToLogin/ReturnToLogin'));

export default function ReturnToLoginLazyLoader(props) {
  return (
    <GenericFallbackSuspense fallback={<span />}>
      <ReturnToLogin {...props} />
    </GenericFallbackSuspense>
  );
}
